import React, { useState, useEffect, useRef } from "react";
import { heroCard, Weapons, Armor, Ring, Helmets, Necklace, statCaps, suffixes, multiplier } from "./Vars";
import Tooltip from "./Tooltip";
import totalboost from "../images/totalboost.png";
import unitStat from "../images/ModedStat.png"
import InputValidation from "./InputValidation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";



export default function HeroCardCalculator() {

  function formatLargeNumber(num, precision = 3, t = false ) {
    
    if (num === 0) return "0";
    if (num < 1000 && !t) return num.toPrecision(precision);
  
    const tier = Math.floor(Math.log10(Math.abs(num)) / 3);
    const suffix = suffixes[tier] || `e${tier * 3}`;
    const scaled = num / Math.pow(10, tier * 3);
    if (!t) {
      return scaled.toPrecision(precision) + suffix;
    }
    return [scaled.toPrecision(precision), tier]; 
  }
  function lettersToNumber(input) {
    const match = input.match(/([A-Za-z]{1,2})$/);
    if (!match && !isNaN(input)) return 0;
    else if (!match) return null;

    const letters = match[1];
    let value, result;

    if (letters.length === 1 && letters in multiplier) {
      return multiplier[letters];
    }

    for (let i = 0; i < letters.length; i++) {
      const char = letters[i];
      if (char >= 'A' && char <= 'Z') {
        value = char.charCodeAt(0) - 60; // A=5, B=6, ..., Z=31
      } else {
        value = null;
      }

      if (i === 0) {
        result = value;
      } else {
        result = (result - 4) * 26 + value;
      }
    }

    return result;
  }
  const [showTooltip, setShowTooltip] = useState(false);
  const infoRef = useRef(null);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const [currentIndex, setCurrentIndex] = useState(0);
  const [gameSpeed, setGameSpeed] = useState(1.25);
  const [userInputs, setUserInputs] = useState({});
  const [inputErrors, setInputErrors] = useState({});
  const [flashes, setFlashes] = useState({});
  const [flashes2, setFlashes2] = useState(null);
const [openDropdownKey, setOpenDropdownKey] = useState(null);
const dropdownRef = useRef(null);
const prevValuesRef = useRef({});

useEffect(() => {
  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setOpenDropdownKey(null);
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  const [selectedGear, setSelectedGear] = useState({
    gear1a: "",
    gear1b: "",
    gear2: "",
    gear3: "",
    gear4: "",
    gear5: "",
  });
  const handleMouseEnter = () => {
    if (infoRef.current) {
      const rect = infoRef.current.getBoundingClientRect();
      setTooltipPos({ x: rect.left + rect.width / 2, y: rect.bottom });
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };
  
  const GAME_SPEED_CAP = 2;
  const GAME_SPEED_DEFAULT = 1.25; 

  const rarities = {
  Common: 'text-gray-500',
  Rare: 'text-blue-500',
  Epic: 'text-purple-500',
  Legendary: 'text-amber-500',
};

  const unit = heroCard[currentIndex];

  const getItemStats = () => {
    const all = [];
    const findItem = (list, name) => list.find((item) => item.name === name) || { stats: {} };

    all.push(findItem(Weapons, selectedGear.gear1a));
    all.push(findItem(Weapons, selectedGear.gear1b));
    all.push(findItem(Armor, selectedGear.gear2));
    all.push(findItem(Ring, selectedGear.gear3));
    all.push(findItem(Helmets, selectedGear.gear4));
    all.push(findItem(Necklace, selectedGear.gear5));

    const merged = {};
    all.forEach((item) => {
      for (const key in item.stats) {
        merged[key] = (merged[key] || 1) + item.stats[key];
      }
    });
    return merged;
  };
  const defaultUserInputs = {
  Attack: "",
  Health: "",
  Range: "", 
  AttackSpeed: "",
  CritChance: "",
  CritAttack: "",
  BlockChance: "",
  MoveSpeed: "",
  LifeSteal: ""
};
const [rawInputs, setRawInputs] = useState({});

const maxUserInputs = {
  Range: "", 
  AttackSpeed: "",
  CritChance: "0.125",
  CritAttack: "6.27",
  BlockChance: "0.125",
  MoveSpeed: "",
  LifeSteal: ""
};
  const handleReset = () => {
    setRawInputs(defaultUserInputs);
    setUserInputs(defaultUserInputs);
    setGameSpeed(1.25);
    setSelectedGear({
    gear1a: "",
    gear1b: "",
    gear2: "",
    gear3: "",
    gear4: "",
    gear5: "",
  });
  }

  const handleMax = () => {
  setRawInputs(prev => {
    const updated = { ...prev };
    for (const key in maxUserInputs) {
      if (maxUserInputs[key] !== "") {
        updated[key] = maxUserInputs[key];
      }
    }
    return updated;
  });

  setUserInputs(prev => {
    const updated = { ...prev };
    for (const key in maxUserInputs) {
      if (maxUserInputs[key] !== "") {
        updated[key] = parseFloat(maxUserInputs[key]);
      }
    }
    return updated;
  });

    setGameSpeed(1.25);
    setSelectedGear({
    gear1a: "Ruby Sword",
    gear1b: "Siren",
    gear2: "S.C.A.-02",
    gear3: "Cobalt",
    gear4: "Crown",
    gear5: "Mountain Blood",
  });
  }

  const mergeStats = (base, bonus) => {
    const keys = new Set([...Object.keys(base), ...Object.keys(bonus)]);
    const based = ["CritChance", "BlockChance"];
    const merged = {};

    keys.forEach((key) => {
      let baseVal = base[key] ?? 0;
      let bonusVal = bonus[key] ?? 0;

      if (based.includes(key)) {
        if (baseVal === 0 && bonusVal === 0) {
          merged[key] = 0;
        } else {
          baseVal = baseVal > 1 ? baseVal : baseVal + 1;
          bonusVal = bonusVal > 1 ? bonusVal : bonusVal + 1;
          merged[key] = baseVal * bonusVal - 1;
        }
      } else {
        merged[key] = baseVal === 0 && bonusVal === 0 ? 0 : baseVal === 0 ? bonusVal : bonusVal === 0 ? baseVal : baseVal * bonusVal;
      }
    });

    return merged;
  };

  const calculateDPS = (stats) => {
    const attack = stats.Attack;
    const speed = stats.AttackSpeed;
    const critRate = stats.CritChance || 0;
    const critMult = stats.CritAttack || 0;
    const baseDPS = attack * speed;
    const critBoost = 1 + critRate * (critMult - 1);
    return baseDPS * critBoost;
  };

function nCr(n, r){
    if (r > n) return 0; 
    if (r=== 0 || r === n) return 1; 
    let numerator = 1;
    let denominator = 1; 
    for (let i =1; i<=r; i++){
        numerator *= (n-(i-1));
        denominator *= i;
    }
    return numerator/denominator;
}

function winProbability(n, k, p){
    let sum = 0; 
    for (let i = k; i<=n; i++){
        sum += nCr(n, i) * Math.pow(p, i) * Math.pow(1-p, n-i);
    }
    return sum;
}

function expectedGames(n, k, p){
    const winProb = winProbability(n, k, p);
    return 1/(1-winProb);
}

  function handleGearChange(key, value) {
  setSelectedGear(prev => {
    const newGear = { ...prev, [key]: value };

    if (key === "gear1a" && value === prev.gear1b) {
      newGear.gear1b = "";  // clear weapon 2 if duplicate
    } else if (key === "gear1b" && value === prev.gear1a) {
      newGear.gear1a = "";  // clear weapon 1 if duplicate
    }

    return newGear;
  });

  setOpenDropdownKey(null);
}
function extractNumber(input) {
    const match = input.match(/^(\d+(\.\d+)?)/);    
    return match ? parseFloat(match[1], 10) : null;
}

const handleUserInputChange = (key, val) => {
  setRawInputs(prev => ({ ...prev, [key]: val })); // just store string
};
  
  const handleUserInputBlur = (key) => {
    const val = rawInputs[key]
    if (key === "Attack" || key === "Health") {
    const result = InputValidation([val]);
    setInputErrors((prev) => ({
      ...prev,
      [key]: result === true ? "" : result[0],
    }));
    if(val){
       const convertedValues =  (val) => {
          const base = extractNumber(val);
          const power = lettersToNumber(val);
        return base * Math.pow(1000, power);
        };
        setUserInputs((prev) => ({ ...prev, [key]: (parseFloat(convertedValues(val))) }));
    }
    
  } 
  else{
    setUserInputs((prev) => ({ ...prev, [key]: parseFloat(val) }));
  }
    
  };

  const baseStats = {
    ...unit.stats,
    AttackSpeed: unit.stats.AttackSpeed * gameSpeed,
    MoveSpeed: unit.stats.MoveSpeed * gameSpeed,
  };
  const itemStats = getItemStats();
  const inputStats = Object.keys(baseStats).reduce((acc, key) => {
    acc[key] = parseFloat(userInputs[key] || 0);
    return acc;
  }, {});

  const basePlusInput = mergeStats(baseStats, inputStats);
  const totalStats = mergeStats(basePlusInput, itemStats);
  const dps = calculateDPS(totalStats);
  const effective = dps * (unit.stats.Range || 1);
  const burst = Math.pow(effective / unit.stats.Attack, 1.2) * unit.stats.Attack * Math.pow(unit.stats.AttackSpeed, 0.2);
  const healthy = totalStats.Health/(1-totalStats.BlockChance);

  const shots = unit.hits * totalStats.AttackSpeed / (unit.stats.AttackSpeed * gameSpeed);
  let reliability;
if(totalStats.CritChance === 0){
  reliability = [{
    "Number of crits": 0,
    "Expected number of times": 1,
    "Probability": 100
  }];
}
else {
 reliability = Array.from({ length: Math.floor(shots) }, (_, idx) => {
  const i = idx + 1;
  let winProb = winProbability(shots, i, totalStats.CritChance || 0);
  winProb = winProb < 0.01 ? "<1%" : `${formatLargeNumber(winProb*100)}%`;
  const expGames = expectedGames(shots, i, totalStats.CritChance || 0);
  return {
    "Number of crits": i,
    "Expected number of times": formatLargeNumber(expGames),
    "Probability": winProb
  };
});
}
if (reliability.length === 0) {
  reliability = [{
    "Number of crits": 0,
    "Expected number of times": 1,
    "Probability": 100
  }];
}

useEffect(() => {
  const prevValues = prevValuesRef.current;
  const nextValues = totalStats;
  let prevcritVal = (prevValues["CritAttack"] || 0) * (prevValues["Attack"] || 0);
  let currcritVal = (nextValues["CritAttack"] || 0) * (nextValues["Attack"] || 0);
  Object.keys(nextValues).forEach((key) => {
    let prev, curr;
    let prev2, curr2;

    prev = prevValues[key] || 0;
    curr = nextValues[key] || 0;
    if (key === "CritAttack") {
      prev2 = prevcritVal
      curr2 = currcritVal
    } 
    if (prev !== curr) {
      setFlashes((f) => ({ ...f, [key]: curr > prev ? "up" : "down" }));
      setTimeout(() => {
        setFlashes((f) => ({ ...f, [key]: null }));
      }, 3000);
    }
    if (prev2 !== curr2){
      setFlashes2(curr2 > prev2 ? "up" : "down");
      setTimeout(() => {
        setFlashes2(null);
      }, 3000);
    }
  });

  prevValuesRef.current = { ...nextValues };
}, [totalStats]);

  const statRows = Object.keys(baseStats).map((key) => {
    const base = baseStats[key] || 0;
    const input = inputStats[key] || 0;
    const itemMult = itemStats[key] || 0;
    const total = totalStats[key] || 0;
    const flash = flashes[key];
    const flash2 = flashes2; 
    const cap = statCaps?.[key];
    const warn = cap !== undefined && input > cap;
    
    return (
      <tr key={key}>
        <td className="border px-2 py-1 text-left font-semibold">{key}</td>
        <td className="border px-2 py-1 text-right">{formatLargeNumber(base)}</td>
        <td className="border px-2 py-1 text-right">
          <input
            type="text"
            className={`w-20 text-right p-1 border ${warn ? "border-red-500 bg-red-100" : "border-gray-300"} rounded text-l`}
            value={rawInputs[key] ?? ""}  // controlled input
            onChange={(e) => handleUserInputChange(key, e.target.value)}
            onBlur= {() => handleUserInputBlur(key)}
          />
          {warn && <div className="text-xs text-red-500 mt-1">⚠ Exceeds the maximum values found in game (check your total boosts, use decimals instead of percentages)</div>}
          {inputErrors[key] && (
  <div className="text-xs text-red-500 mt-1">{inputErrors[key]}</div>
)}
        </td>
        <td className="border px-2 py-1 text-right">× {formatLargeNumber(itemMult)}</td>
        <td className={`border px-2 py-1 text-right text-blue-600 font-semibold 
        ${flash === "up" ? "text-green-500 font-bold" : 
          flash === "down" ? "text-red-500 font-bold" :
          "text-black"}`}
        >{formatLargeNumber(total)} {key === "CritAttack" && (
    <span className={`text-lg text-gray-500 ml-1 
      ${flash2 === "up" ? "text-green-500 font-bold" : 
          flash2 === "down" ? "text-red-500 font-bold" : 
        "text-black"}`}>({formatLargeNumber(total*totalStats.Attack)})</span>
  )}</td>
      </tr>
    );
  });

  return (
     <div className="relative bg-white/60 p-6 rounded-md border shadow-md transition">
      
      <div className="flex items-center justify-center mb-4 relative ">
        <h1 className="text-3xl font-bold mr-2">Hero Stats (testing version &lt; 1.56)</h1>
        <div
          ref={infoRef}
          className="text-sm text-blue-500 cursor-pointer"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={() => {
            if (window.innerWidth <= 768) {
              handleMouseEnter();
              setTimeout(() => setShowTooltip(false), 5000);
            }
          }}
        >
          ℹ️
        </div>

        {showTooltip && (
          <Tooltip
  position={{
    x: tooltipPos.x,
    y: tooltipPos.y,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
  }}
>
  <div className="max-h-[300px] max-w-[400px] overflow-y-auto p-2">
    <p className="whitespace-pre-line mb-2">
      {"Displays hero base stats, hero gear effects, and calculates total actual values for each hero.\nYou can input total boosts (% in decimals please) or game speed since hero's stats are influenced by your unit's attack and health (not the one in parenthesis), and crit/block stuff from runes. \n NOTE: DPS is calculated through weighted average, Effective Zone multiplies in Range, Burst DPS favors Range, Attack Speed, and Crit (still tweaking)."}
    </p>

    <div className="flex flex-row flex-wrap justify-center gap-2">
      {totalboost && (
        <img
          alt="Total Boost Visual"
          src={totalboost}
          className="w-[200px] rounded-lg"
        />
      )}
      {unitStat && (
        <img
          alt="Unit Boost Visual"
          src={unitStat}
          className="w-[200px] rounded-lg"
        />
      )}
    </div>
  </div>
</Tooltip>
        )}
      </div>
    <div className="bg-white rounded-xl shadow-md p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4 text-center">{unit.name}</h2>

      {/* Game Speed Input */}
      <div className="flex flex-col items-center mb-4">
        <label className="text-lg font-semibold">Game Speed</label>
        <input
          type="number"
          value={gameSpeed}
          onChange={(e) => setGameSpeed(parseFloat(e.target.value) || 1)}
          className="border rounded px-3 py-2 w-40 text-lg text-center"
        />
        {gameSpeed > GAME_SPEED_CAP && (
          <div className="text-sm text-red-500 mt-1">⚠️ Game Speed above actual game cap ({GAME_SPEED_CAP})</div>
        )}
        {gameSpeed < GAME_SPEED_DEFAULT && (
          <div className="text-sm text-yellow-500 mt-1">⚠️ Game Speed below (new) default settings ({GAME_SPEED_DEFAULT})</div>
        )}
      </div>

      {/* Image */}
      <div className="flex justify-center mb-4 items-center" >
        <FontAwesomeIcon icon={faChevronLeft} className="text-blue-500 text-3xl hover:text-black font-semibold py-2 px-4 rounded-xl active:bg-blue-500"
          onClick={() => setCurrentIndex((prev) => (prev - 1 + heroCard.length) % heroCard.length)} />

        <img src={unit.image} alt={unit.name} className="h-32 w-32 object-contain rounded-lg shadow" />

        <FontAwesomeIcon icon= {faChevronRight} className="text-blue-500 text-3xl hover:text-black font-semibold py-2 px-4 rounded-xl active:bg-blue-500"
          onClick={() => setCurrentIndex((prev) => (prev + 1) % heroCard.length)} />

      </div>

      {/* HeroGear Inputs */}
       <div className="grid grid-cols-2 gap-4 mb-4">
        {[
          { label: "Weapon 1", key: "gear1a", list: Weapons },
          { label: "Weapon 2", key: "gear1b", list: Weapons },
          { label: "Armor", key: "gear2", list: Armor },
          { label: "Ring", key: "gear3", list: Ring },
          { label: "Helmet", key: "gear4", list: Helmets },
          { label: "Necklace", key: "gear5", list: Necklace },
        ].map(({ label, key, list }) => {

          return (
            <div key={key} ref={key === openDropdownKey ? dropdownRef : null}>
  <label className="block text-lg font-medium mb-1">{label}</label>
  <button
    className="p-2 rounded border w-full text-left text-lg"
    onClick={() => setOpenDropdownKey(openDropdownKey === key ? null : key)}
  >
    {selectedGear[key] || "-- Select --"}
  </button>

  {openDropdownKey === key && (
    <div className="border rounded mt-1 absolute bg-white z-10 max-w-xs max-h-60 overflow-y-auto">
      <div
  onClick={() => handleGearChange(key, "")}
  className="cursor-pointer px-2 py-1 hover:bg-gray-100"
>
  -- Select --
</div>
      {list.map((item) => (
        <div
          key={item.name}
          className="px-2 py-1 hover:bg-gray-100 cursor-pointer flex items-center w-full"
          onClick={() => {
            handleGearChange(key, item.name);
            setOpenDropdownKey(null);
          }}
        >
          <span className={`w-2 h-2 rounded-full mr-2 ${rarities[item.rarity]}`} />
          <span className={rarities[item.rarity]}>{item.name}</span>
        </div>
      ))}
    </div>
  )}
</div>
          );
        })}
      </div>
          

      {/* Stat Table */}
      <div className="overflow-x-auto">
      <table className="w-full text-lg mb-3">
        <thead>
          <tr className="bg-gray-200 text-gray-800">
            <th className="border px-2 py-1">Stat</th>
            <th className="border px-2 py-1">Base</th>
            <th className="border px-2 py-1">Total Boost</th>
            <th className="border px-2 py-1">Item x</th>
            <th className="border px-2 py-1">Total</th>
          </tr>
        </thead>
        <tbody>{statRows}</tbody>
      </table>
      </div>

      {/* Results */}
     {/* First card: DPS etc. */}
<div className="card bg-white shadow-md rounded-xl p-4 mt-4 max-w-4xl mx-auto overflow-x-auto">
  <h2 className="text-2xl font-bold mb-4">Result</h2>
  <div className="flex flex-row flex-wrap gap-3">
    <div className="bg-gray-100 p-3 rounded-lg flex flex-col items-start flex-1 min-w-[150px]">
      <div className="text-lg text-gray-500">DPS</div>
      <div className="text-lg font-semibold">{formatLargeNumber(dps)}</div>
    </div>
    <div className="bg-gray-100 p-3 rounded-lg flex flex-col items-start flex-1 min-w-[150px]">
      <div className="text-lg text-gray-500">Effectiveness Zone</div>
      <div className="text-lg font-semibold">{formatLargeNumber(effective)}</div>
    </div>
    <div className="bg-gray-100 p-3 rounded-lg flex flex-col items-start flex-1 min-w-[150px]">
      <div className="text-lg text-gray-500">Burst DPS</div>
      <div className="text-lg font-semibold">{formatLargeNumber(burst)}</div>
    </div>
    <div className="bg-gray-100 p-3 rounded-lg flex flex-col items-start flex-1 min-w-[150px]">
      <div className="text-lg text-gray-500">Effective Health</div>
      <div className="text-lg font-semibold">{formatLargeNumber(healthy)}</div>
    </div>
  </div>
</div>

{/* Second card: Reliability table */}
<div className="card bg-white shadow-md rounded-xl p-4 mt-4 max-w-4xl mx-auto overflow-x-auto">
  <h2 className="text-2xl font-bold mb-4">Reliability: Number of critical attacks before enemy approaches</h2>

  {/* Grid: first column for labels, rest for numbers */}
  <div
    className="grid gap-2"
    style={{
      gridTemplateColumns: `150px repeat(${reliability.length}, minmax(60px, 1fr))`
    }}
  >
    {/* Crit num row */}
    <div className="bg-gray-100 p-3 rounded-lg font-semibold">Critical attacks out of {Math.floor(shots)}:</div>
    {reliability.map((r, i) => (
      <div key={`crit-${i}`} className="bg-gray-100 p-3 rounded-lg text-center">
        {r["Number of crits"]}
      </div>
    ))}

    {/* Exp game row */}
    <div className="bg-gray-100 p-3 rounded-lg font-semibold">Expected Rounds:</div>
    {reliability.map((r, i) => (
      <div key={`exp-${i}`} className="bg-gray-100 p-3 rounded-lg text-center">
        {r["Expected number of times"]}
      </div>
    ))}

    {/* Probability row */}
    <div className="bg-gray-100 p-3 rounded-lg font-semibold">Probability:</div>
    {reliability.map((r, i) => (
      <div key={`prob-${i}`} className="bg-gray-100 p-3 rounded-lg text-center">
        {r["Probability"]}
      </div>
    ))}
  </div>
</div>

      {/* Navigation */}
      <div className="flex flex-row flex-wrap gap-3 justify-between mt-6">
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl"
          onClick={() => setCurrentIndex((prev) => (prev - 1 + heroCard.length) % heroCard.length)}
        >
          ◀ Prev
        </button>
        <button
    className="bg-gray-400 hover:bg-gray-500 text-white font-semibold py-2 px-4 rounded-xl"
    onClick={handleReset}
  >
    Reset
  </button>
  <button
    className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl"
    onClick={handleMax}
  >
    Best Known Set Up
  </button>
        <button
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl"
          onClick={() => setCurrentIndex((prev) => (prev + 1) % heroCard.length)}
        >
          Next ▶
        </button>
      </div>
    </div>
    </div>
  );
}